<template>
  <v-container class="pt-8">
    <v-row>
      <v-col cols="12" md="12" lg="5" xl="4" class="pa-0">
        <v-container class="pa-0">
          <v-row class="d-block">
            <v-col class="text--secondary text-center text-lg-left pt-0" cols="12">
              <h1>{{applicant.name}}</h1>
              <h5>
                <a
                  class="blue--text nolink"
                  :href="`mailto://${applicant.email}`"
                >{{applicant.email}}</a>
              </h5>
              <h5 v-if="applicant.phone">
                <a
                  class="blue--text nolink"
                  :href="`tel://${applicant.phone}`"
                >{{applicant.phone |phone}}</a>
              </h5>
              <h4>
                <span class="caption">{{applicant.date_added|fromNow}}</span>
              </h4>
            </v-col>
          </v-row>
          <v-row class="d-none">
            <v-col cols="12" class="py-2">
              <v-text-field
                label="Name"
                hide-details
                dense
                outlined
                readonly
                :value="applicant.name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-2">
              <v-text-field
                label="Email"
                hide-details
                dense
                outlined
                readonly
                :value="applicant.email"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-2" v-if="applicant.phone">
              <v-text-field
                label="Phone"
                hide-details
                dense
                outlined
                readonly
                :value="applicant.phone"
                append-icon="fa-phone"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class>
            <v-col cols="12" class="text-center text-lg-left pt-0">
              <v-btn x-small dark color="error" fab class="mr-1" @click="deleteApplicant">
                <v-icon x-small>fa-trash</v-icon>
              </v-btn>
              <v-menu :close-on-content-click="false" offset-x>
                <template v-slot:activator="{on,attrs}">
                  <v-btn
                    dark
                    x-small
                    color="#9054ff"
                    fab
                    class="ml-1 mr-1"
                    v-on="on"
                    v-bind="attrs"
                  >
                    <v-icon x-small>fa-share</v-icon>
                  </v-btn>
                </template>
                <v-card style="overflow:hidden">
                  <v-list class="py-0">
                    <v-list-item class="secondary">
                      <v-list-item-content class="white--text">Share Applicant</v-list-item-content>
                      <v-list-item-action>
                        <v-btn
                          title="Copy to clipboard"
                          :color="copied? 'green' : '#9054ff'"
                          dark
                          x-small
                          :fab="copied ? false : true"
                          :text="copied ?true : false"
                          v-clipboard:success="onCopySucces"
                          v-clipboard:error="onCopyError"
                          v-clipboard:copy="shareLink"
                        >
                          <span class="caption" v-if="copied">Copied!</span>
                          <v-icon x-small v-else>fa-paperclip</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-content>
                        <a :href="shareLink" target="_blank" class="caption">{{shareLink}}</a>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col cols="12" md="12" lg="7" xl="8" class="pa-0">
        <v-card>
          <v-card-title class="cyan white--text py-0">
            <h5>My Notepad</h5>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-textarea
            hide-details
            dense
            filled
            :rows="$vuetify.breakpoint.name==='xs' ? 6 : 4"
            @change="onChange"
            v-model="applicant.notes"
            style="font-size: 13px;"
          ></v-textarea>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ApplicantViewInfo",
  props: ["value"],
  data() {
    return {
      new_note: "",
      copied: false,
      show_notes: false
    };
  },
  created() {
    this.new_note = "";
  },
  watch: {
    value: function() {
      this.new_note = "";
    }
  },
  beforeDestroy() {},
  computed: {
    applicant() {
      return this.value;
    },
    shareLink() {
      return `${window.location.origin}/applicant-view/${this.applicant.uid}`;
    }
  },
  methods: {
    onCopySucces() {
      this.copied = true;
      setTimeout(
        function() {
          this.copied = false;
        }.bind(this),
        1000
      );
    },
    onCopyError() {
      alert("Couldnt copy link, please copy the link manually.");
    },
    deleteApplicant() {
      if (
        !confirm(
          "Sure you want to delete this applicant ? All files will be permanently deleted"
        )
      ) {
        return;
      }

      this.$emit("delete");
    },
    removeNote(note) {
      if (!confirm("Sure you want to delete that note ?")) {
        return;
      }
      this.applicant.notes = this.applicant.notes.filter(n => {
        return n !== note;
      });
      this.onChange();
    },
    addNote() {
      if (!this.new_note) {
        return;
      }
      this.applicant.notes.push({ note: this.new_note, date: new Date() });

      this.new_note = "";
      this.onChange();
    },
    onChange() {
      this.$emit("change");
    }
  }
};
</script>

<style>
</style>